module.exports = __webpack_public_path__ + "img/collection-diamondJewelryBudgetLow.7f9620f.jpg";